// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1zp78","paramInput":"JobSimulator_paramInput__267d9","input":"JobSimulator_input__WIubK"};